import React from 'react';
import './header.scss';

export function Header() {
  return (
    <header>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5">
            <div className='logo'></div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7">
            <div className='topcontact'>
              <h4 className="lead24">Работаем с 10:00 до 22:00</h4>
              <h4 className="d-none d-sm-none d-md-none d-lg-block d-xl-block phone header-tel"><small>(812)</small> 921 36 26</h4>
              <h4 className="d-sm-block d-md-block d-lg-none d-xl-none phone header-tel"><a href="tel:88129213626"><small>(812)</small> 921 36 26</a></h4>
              <div className="lead-address">
                <a className="lead addr" href="#contact">
                  <span className="locality">Янино-1</span><br />
                  <span className="street-address">Шоссейная улица, дом 77</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
